class MemberType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`members.type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(memberType) {
        return memberType === this;
    }
}

export const MEMBER = new MemberType('MEMBER');
export const AUCTIONEER = new MemberType('AUCTIONEER');
export const TECHNICAL_AUCTIONEER = new MemberType('TECHNICAL_AUCTIONEER');
export const AUCTIONEER_AND_TECH_AUCTIONEER = new MemberType('AUCTIONEER_AND_TECH_AUCTIONEER');
export const OPERATOR = new MemberType('OPERATOR');

export const getMemberType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'MEMBER':
            result = MEMBER;
            break;
        case 'AUCTIONEER':
            result = AUCTIONEER;
            break;
        case 'TECHNICAL_AUCTIONEER':
            result = TECHNICAL_AUCTIONEER;
            break;
        case 'AUCTIONEER_AND_TECH_AUCTIONEER':
            result = AUCTIONEER_AND_TECH_AUCTIONEER;
            break;
        case 'OPERATOR':
            result = OPERATOR;
            break;
        default:
            throw new Error(`Unknown member type: ${serverType}`);
    }
    return result;
};

export const getAllMemberTypes = () => [
    MEMBER,
    AUCTIONEER,
    TECHNICAL_AUCTIONEER,
    AUCTIONEER_AND_TECH_AUCTIONEER,
    OPERATOR,
];
